import {
  type QueryKey,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

// useQuery with eternal cache, to avoid any re-fetch of the data
// Useful for fixed data that will never changes

const useQueryOnce = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> =>
  useQuery<TQueryFnData, TError, TData, TQueryKey>({
    ...options,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

export default useQueryOnce;
